import React from 'react';
import { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';
import { getGlobalCXContext } from '~/components/ClientExperience/providers/global-context/global-cx-context.factory';
import { ensureGlobalCXContextInit } from '~/components/ClientExperience/providers/global-context/global-cx-context.utils';
import { GlobalContextProvider } from '~/providers/global.provider';

export function GlobalCXProvider({ children }) {
    const globalCXContext = getGlobalCXContext();

    ensureGlobalCXContextInit(globalCXContext);

    return (
        <GlobalContextProvider<GlobalCXContextValue> global={globalCXContext}>
            {children}
        </GlobalContextProvider>
    );
}
